module.exports = {
  development: {
    baseUrl: "/api",
    mockUrl: "https://www.amazonsurveyzone.com",
    // mockUrl: "http://172.3.1.2:8081",
  },
  production: {
    baseUrl: "/api",
    mockUrl: "https://xxxx",
  },
};
